/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BookingSlot } from './bookingSlot';


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingDay { 
    date: string;
    isPast: boolean;
    slots: Array<BookingSlot>;
}
export const BookingDay_date_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingDay_isPast_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingDay_slots_Validators: ValidatorFn[] =
    [  Validators.required, ];


